import { applyMiddleware, combineReducers, compose, createStore } from 'redux';
import thunk from 'redux-thunk';
import { routerMiddleware , LOCATION_CHANGE } from 'connected-react-router';
import { History } from 'history';
import { ApplicationState, reducers } from './';
import { persistStore, persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import LZString from 'lz-string';


export default function configureStore(history: History, initialState?: ApplicationState) {
    const middleware = [
        thunk,
        routerMiddleware(history)
    ];

    const persistConfig = {
        timeout: 2000, //Set the timeout function to 2 seconds
        key: 'root',
        storage: storage,
        whitelist: ['reeferStatus', 'home', 'dryStatus', 'gensetStatus', 'preferenceSettings', 'rcdStatus', 'cargoCareSettingsData','deploymentStatus','subscriptionManager'],
        transforms: [
            {
                in: (state) => ({
                    ...state,
                    user: compressData(state.user),
                }),
                out: (state) => ({
                    ...state,
                    user: decompressData(state.user),
                }),
            },
        ],

    }
    const compressData = (data) => {
        return LZString.compressToBase64(JSON.stringify(data));
    };

    // Decompress data when loading it from storage
    const decompressData = (compressedData) => {
        return JSON.parse(LZString.decompressFromBase64(compressedData));
    };
    const routerReducer = (history) => {
        const initialState = {
            location: history.location,
            action: history.action,
        };
        return (state = initialState, arg: any = {}) => {
            if (arg.type === LOCATION_CHANGE) {
                return { ...state, ...arg.payload };
            }
            return state;
        }
    };

    const rootReducer = combineReducers({
        ...reducers,
        router: routerReducer(history)
    });
    const persistedReducer = persistReducer(persistConfig, rootReducer)
    const enhancers = [];
  
    const windowIfDefined = typeof window === 'undefined' ? null : window as any;
    if (windowIfDefined && windowIfDefined.__REDUX_DEVTOOLS_EXTENSION__) {
        enhancers.push(windowIfDefined.__REDUX_DEVTOOLS_EXTENSION__());
    }

    const store = createStore(
        persistedReducer,
        initialState,
        compose(applyMiddleware(...middleware), ...enhancers));
        persistStore(store);

    return store;
}


